import {GetterTree} from "vuex";
import {RootState} from "@service/store/types/RootState";
import {WebConferenceState} from "@share/web-conferences/store/WebConferenceState";

export const joinedUserIdsGetter = 'webConference/joinedUserIds';
export const presentersGetter = 'webConference/presenters';
export const agoraGetter = 'webConference/agora';
export const tracksManagerGetter = 'webConference/tracksManager';
export const raisedHandUsersGetter = 'webConference/raisedHandUsers';
export const removedSpeakersGetter = 'webConference/removedSpeakers';
export const recordingStartedGetter = 'webConference/recordingStarted';
export const isSharingGetter = 'webConference/isSharing';

export const getters: GetterTree<WebConferenceState, RootState> = {
    joinedUserIds: state => (key: string) => {
        return state.joinedUserIds[key] ?? [];
    },
    presenters: state => (key: string) => {
        return state.presenters[key] ?? [];
    },
    agora: state => (key: string) => {
        return state.agora ? state.agora[key] : null;
    },
    raisedHandUsers: state => (key: string) => {
        return state.raisedHandUsers[key] ?? [];
    },
    removedSpeakers: state => (key: string) => {
        return state.removedSpeakers[key] ?? [];
    },
    recordingStarted: state => (key: string) => {
        return state.recordingStarted[key] ?? false;
    },
    isSharing: state => (key: string) => {
        if (state.webConferenceData[key] && state.webConferenceData[key] != null) {
            return state.webConferenceData[key].isSharing();
        }

        return  false;
    },
    tracksManager: state => (key: string) => {
        return state.tracksManager[key] ?? {};
    }
}
